import type { IToggleBranchPurchaseLimitParams } from 'core/model/interfaces/distributors/branches.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import type { IDistributorsState } from '../../types';

export const toggleBranchPurchaseLimit = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/toggleBranchPurchaseLimit`,
  async (params: IToggleBranchPurchaseLimitParams, { rejectWithValue }) => {
    const { purchaseLimit } = params;

    try {
      await apiService.branches.toggleBranchPurchaseLimit(params);

      notificationService.global.success(
        `Se [${purchaseLimit.enabled ? 'desactivó' : 'activó'}] el límite de compras correctamente.`,
      );
    } catch (error) {
      notificationService.global.error(
        `Error al [${purchaseLimit.enabled ? 'desactivar' : 'activar'}] el límite de compras.`,
      );

      return rejectWithValue(error);
    }
  },
);

export const toggleBranchPurchaseLimitReducer: TSliceExtraReducer<IDistributorsState> = builder =>
  builder
    .addCase(toggleBranchPurchaseLimit.pending, state => {
      state.branchesList.form.loading = true;
      state.branchesList.form.success = false;
      state.branchesList.form.errors = {};
    })
    .addCase(toggleBranchPurchaseLimit.rejected, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = false;
    })
    .addCase(toggleBranchPurchaseLimit.fulfilled, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = true;
      state.branchesList.form.errors = {};
    });
